/*** IMPORTS FROM imports-loader ***/


/**
 * GIS Server APIs
 * A powerful suite of mapping, geospatial and location-based APIs for your applications and services.
 *
 * OpenAPI spec version: v1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.GisServerApis) {
      root.GisServerApis = {};
    }
    root.GisServerApis.LatLonResource = factory(root.GisServerApis.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The LatLonResource model module.
   * @module model/LatLonResource
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>LatLonResource</code>.
   * A class that presents the lat-lon for coordinates.
   * @alias module:model/LatLonResource
   * @class
   */
  var exports = function() {
    var _this = this;



  };

  /**
   * Constructs a <code>LatLonResource</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/LatLonResource} obj Optional instance to populate.
   * @return {module:model/LatLonResource} The populated <code>LatLonResource</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('latitude')) {
        obj['latitude'] = ApiClient.convertToType(data['latitude'], 'Number');
      }
      if (data.hasOwnProperty('longitude')) {
        obj['longitude'] = ApiClient.convertToType(data['longitude'], 'Number');
      }
    }
    return obj;
  }

  /**
   * The vlaue of latitude.
   * @member {Number} latitude
   */
  exports.prototype['latitude'] = undefined;
  /**
   * The value of longitude.
   * @member {Number} longitude
   */
  exports.prototype['longitude'] = undefined;



  return exports;
}));



